export enum ActivitySection {
    USER_LIST,
    ONE_USER_ACTIVITY,
    USER_LIST_ACTIVITY
}